import * as React from 'react';
import { connect } from 'react-redux';
import DEform from '../../forms/deForm';
import TransForm from '../../forms/transferForm';
import AssetForm from '../../forms/assetForm';
import PaymentForm from '../../forms/paymentForm';

//import styles from './styles';
import Alert from '../../components/alert';
import { Container, Header, Content, Text, Label, Item, Input, Icon, Toast, Footer, Form, Spinner, View, Left, Right, Body, Button, Title } from 'native-base';

import * as _ from 'lodash';
import CalCalDataApi from '../../api/CalCalDataApi';
import { updateDayTotals } from '../DailyEntries/actions';
import { updateCustomerDebt, fetchList } from '../People/actions';
import XDate from 'xdate';
import styles from './styles';
import { formValueSelector, change, SubmissionError } from 'redux-form';
import diff from 'object-diff';
import KeyHandler from '../../components/keyHandler';

//import stylesheet from '../../components/tcomb-styles';
//form options for receipt and takings forms?
//Get the entry from appropriate thingy (and make it load as necessary)

//Redux-form: https://medium.com/wolox-driving-innovation/https-medium-com-wolox-driving-innovation-easy-forms-in-react-native-with-redux-form-1cdc16a9a889
//Picker https://github.com/GeekyAnts/NativeBase/issues/349

class DEformContainer extends React.Component {
	constructor(props) {
		super(props);

		this.initialState = {
			isLoading: true,
			isError: false,
			data: [],
			//options: this._getFormOptions(),
			formLoaded: false,
			adding: false,
			isSaving: false,
			entry: null
		};
		this.state = this.initialState;
	}

	componentDidMount() {
		//console.log(this.props.customerId);

		const { params } = this.props.route;
		//we get either transId, receiptId or takingId
		var transId = params.transId;
		const { receiptId, expenseId, assetId, addTrans, addDate, copyId, paymentOnly } = params;
		var entry = null;
		__DEV__ && console.log('DEformContainer with ', params);
		if (assetId && assetId != 'null') {
			//technically we have been given an expense and want to edit the underlying asset
			this.transType = 'asset';
			transId = assetId;
		} else if (receiptId) {
			this.transType = 'receipt';
			transId = receiptId;
		} else if (expenseId) {
			this.transType = 'expense';
			transId = expenseId;
		} else if (params.transferId) {
			this.transType = 'transfer';
			transId = params.transferId;
		} else if (transId) {
			//from dailyEntries all-thingy with added last digit indicating type
			var lastchar = transId.slice(-1);
			transId = transId.slice(0, -1);
			this.transType = lastchar == '1' ? 'receipt' : lastchar == '2' ? 'expense' : 'transfer';
		} else if (copyId) {
			this.transType = addTrans;
			return this.copyTransaction(copyId, this.transType);
		} else {
			//no ids - NEW!
			this.transType = addTrans;
			const expenseDate = addDate || new Date().toISOString().split('T')[0];
			const { total, pic } = params;
			const zero = '0.00';
			if (this.transType == 'transfer') {
				entry = params.entry || { transferDate: expenseDate, amount: zero, fromAcct_id: '3', toAcct_id: '4' };
				//console.log(this.transType, entry);
			} else if (this.transType == 'asset') {
				entry = params.entry || { purchaseDate: expenseDate, net: zero, gross: zero, lastPURate: 0 };
			} else {
				const mores = this.transType == 'receipt' ? { takingCategory_id: '0', customer_id: params.customer_id || 0 } : { expenseCategory_id: 0, supplier_id: params.supplier_id || 0 };
				if (paymentOnly) mores.description = 'Payment on Account';
				entry = params.entry || { expenseDate, account_id: 0, net: total || zero, payable: total || zero, paid: total || zero, vat: zero, ...mores };
				if (!!pic) entry.pic = pic;
				//console.log(this.transType, entry);
			}
			//this.props.dispatch({ type: 'LOAD/dailyEntry', payload: { entry } });
			this.setState({ adding: true, entry });
			return;
		}
		this.loadTransaction(transId, this.transType);
	}

	componentWillUnmount() {
		//this.props.dispatch({ type: 'LOAD/dailyEntry', payload: {} });
	}

	/*componentWillReceiveProps(nextProps){
		console.log('cont nextProps.customers',nextProps.customers)
	}*/

	shouldComponentUpdate(nextProps, nextState) {
		//console.warn(nextProps);
		if (nextProps.customers != this.props.customers || nextProps.suppliers != this.props.suppliers) return true;
		if (nextState != this.state) return true;
		if (nextProps.formVals != this.props.formVals) {
			//being careful on formVals change
			if (!this.showAccts && nextProps.formVals.paid && parseFloat(nextProps.formVals.paid) != 0) return true;
			if (this.showAccts && nextProps.formVals.paid && parseFloat(nextProps.formVals.paid) == 0) return true;
			if (nextProps.formVals.supplier_id != this.props.formVals.supplier_id) return true;
			if (nextProps.formVals.expenseCategory_id != this.props.formVals.expenseCategory_id) return true;
			//console.log('NOT updating DEFormContainer!!', nextProps.formVals);
			return false;
		}
		return true;
	}

	loadTransaction(id, transType) {
		//no need for redux. Just one transaction; load it
		__DEV__ && console.log('loading for ', id, transType);
		//this.props.loadEntry(transType, id);
		var path = 'dailyEntries/' + transType + '/' + id;
		CalCalDataApi.dataLoad(path, this.props.jwt, res => {
			if (!res.error) {
				this.setState({ entry: res });
			} else {
				this.setState({ isError: res.error });
			}
		});
	}

	copyTransaction(id, transType) {
		var path = 'dailyEntries/' + transType + '/' + id;
		CalCalDataApi.dataLoad(path, this.props.jwt, res => {
			if (!res.error) {
				delete res.id;
				delete res.setransaction_id;
				delete res.receipt_ref;
				delete res.asset_id;
				delete res.series_id;
				delete res.series_freq;
				res.expenseDate = new Date().toISOString().split('T')[0];

				this.setState({ entry: res, adding: true });
			} else {
				this.setState({ isError: res.error });
			}
		});
	}

	async saveRecord() {
		//button does this

		this.setState({ isSaving: true });
		setTimeout(() => this.setState({ isSaving: false }), 6000);
		let errors = await this.refs.form.submit();
		//etc - set states and return errors
		__DEV__ && console.log('errors', errors);
		if (errors != false || errors == undefined) this.setState({ isSaving: false });
	}

	onAddAsset() {
		//this.props.dispatch({ type: 'LOAD/dailyEntry', payload: { entry } });
		this.props.navigation.navigate('Entry', { addTrans: 'asset' });
		this.componentDidMount();
	}

	handleSubmit(values) {
		__DEV__ && console.log('handleSubmit got values', values);
		const { params } = this.props.route;
		const { callBack } = params;
		const { dispatch, jwt } = this.props;
		delete values.undefined;
		delete values.notvat;
		const orig = this.state.entry;
		if (this.state.adding) {
			//return the promise so submissionerrors bubble up

			delete values.expenseDateDate;

			//NEW
			//console.log('SUBITTing', values);
			return CalCalDataApi.dataInsert('dailyEntries/' + this.transType, values, jwt, res => {
				//console.log('handleSubmit ',res)
				if (res.success && res.id) {
					//this.insertId = res.id.toString() + transType == 'receipt' ? '1' : '2'; //hard coded here for offline compat
					dispatch({
						type: 'INSERT/dailyEntry', //successful update send UPDATE(d) to store
						entry: res.record, //{...values, id:this.insertId, dayTotals:{}, transaction_type: this.transType }			//HAS to include response for correct ID
						customer_id: orig.customer_id,
						supplier_id: orig.supplier_id
					});
					dispatch(updateDayTotals(res.record.expenseDate));
					if (res.record.customer_id) dispatch(updateCustomerDebt(res.record.customer_id));
					this.setState({ isSaving: false });
					if (callBack) callBack(true);
					this.props.navigation.goBack();
					return false;
				} else if (res.validationErrors) {
					console.log('validationErrors ', res.validationErrors);
					throw new SubmissionError(res.validationErrors);
				} else {
					Alert.alert('Save failed, error ' + res.error + ' ' + res.status);
					throw new SubmissionError({ expenseDate: res.error });
				}
			});
		} else {
			var difference = diff(orig, values); //added, deleted, changed, updated (arrays)

			if (Object.keys(difference).length == 0)
				//console.log('diff:', difference);
				return new Promise(function (resolve, reject) {
					resolve();
				}); //needs to be thunky promise

			difference.id = orig.id; //send the id down to store!
			var storeDiffs = {};
			if (difference.customer_id) storeDiffs.name = _.find(this.props.customers, ['id', difference.customer_id]).display; //hack to keep display in dailyEntries/
			if (difference.expenseCategory_id) storeDiffs.name = _.find(this.props.expenseCategories, ['id', difference.expenseCategory_id]).categoryName;
			__DEV__ && console.log('SUBITTing', difference, values, orig);
			return CalCalDataApi.dataUpdate('dailyEntries/' + this.transType + '/' + orig.id, difference, jwt, res => {
				//console.log('handleSubmit ',res)
				if (this.transType == 'transfer') difference.paid = difference.amount;
				if (res.success) {
					dispatch({
						type: 'UPDATE/dailyEntry', //successful update send UPDATE(d) to store
						id: orig.id, //this is actual (real_id)
						transType: this.transType,
						difference, //IF no JSON returned, trust local changes
						origDate: orig.expenseDate || orig.transferDate || orig.purchaseDate,
						storeDiffs
					});
					dispatch(updateDayTotals(orig.expenseDate || orig.transferDate || orig.purchaseDate));
					if (orig.customer_id) dispatch(updateCustomerDebt(orig.customer_id));
					if (difference.customer_id) dispatch(updateCustomerDebt(difference.customer_id));
					this.setState({ isSaving: false });
					this.props.navigation.goBack();
					return false;
				} else if (res.validationErrors) {
					console.log('validationErrors ', res.validationErrors);
					throw new SubmissionError(res.validationErrors);
				} else {
					Alert.alert('Save failed, error ' + res.status + ' ' + res.statusText);
					throw new SubmissionError(res.title);
				}
			});
		}
	}

	render() {
		//if(!this.state.entry) return (<Spinner />);
		//__DEV__ && console.log('REDNER DECONT', this.props);
		const { params } = this.props.route;
		const paymentOnly = params.paymentOnly || (this.state.entry && this.state.entry.expenseCategory_id == -1);
		var { vatRate } = this.props;
		//no vat if takingCategory_id 's outOfVatScope = 1
		this.showAccts = parseFloat(this.props.formVals.paid) != 0;

		if (this.props.formVals.expenseCategory_id) {
			const cat = _.find(this.props.expenseCategories, ['id', this.props.formVals.expenseCategory_id]);
			if (cat && cat.outOfVatScope == 1) vatRate = 0;
		}
		//__DEV__ && console.log(this.props.formVals.expenseCategory_id, cat && cat.outOfVatScope, vatRate);

		const { adding } = this.state;
		if (this.state.isError) {
			return (
				<Container>
					<Header>
						<Left>
							<Button transparent onPress={() => this.props.navigation.goBack()}>
								<Icon name="close" />
							</Button>
						</Left>
						<Text style={{ color: 'red' }}>Error loading transaction!</Text>
					</Header>
				</Container>
			);
		} else {
			return (
				<Container>
					{!this.state.isSaving ? (
						<Header>
							<Left>
								<Button transparent onPress={() => this.props.navigation.goBack()}>
									<Icon name="close" />
								</Button>
							</Left>

							<Body style={{ flex: 3 }}>
								<Title>
									{this.state.adding ? 'Add' : 'Edit'} {this.transType}
								</Title>
							</Body>

							<Right>
								<Button transparent onPress={() => this.saveRecord()}>
									<Icon name="checkmark" />
								</Button>
							</Right>
							<KeyHandler esc={() => this.props.navigation.goBack()} enter={() => this.saveRecord()} />
						</Header>
					) : (
						<Header>
							<Spinner />
						</Header>
					)}
					{this.state.entry && this.state.entry.expenseDate && this.transType != 'transfer' && !paymentOnly && (
						<DEform
							recurring={adding ? false : this.state.entry.series_freq}
							isNew={this.state.adding}
							canRecur={!this.state.entry.series_id && !!this.props.formVals.supplier_id}
							transType={this.transType}
							customers={this.props.customers}
							suppliers={this.props.suppliers}
							accounts={this.props.accounts}
							vatReg={this.props.vatReg}
							vatRate={vatRate}
							categories={this.transType == 'receipt' ? this.props.takingCategories : this.props.expenseCategories}
							initialValues={this.state.entry}
							showAccts={this.showAccts}
							onSubmit={this.handleSubmit.bind(this)}
							swapToAsset={this.onAddAsset.bind(this)}
							ref="form"
						/>
					)}
					{this.state.entry && this.state.entry.transferDate && this.transType == 'transfer' && (
						<TransForm accounts={this.props.accounts} initialValues={this.state.entry} onSubmit={this.handleSubmit.bind(this)} ref="form" />
					)}
					{this.state.entry && this.state.entry.expenseDate && paymentOnly && (
						<PaymentForm
							transType={this.transType}
							accounts={this.props.accounts}
							initialValues={this.state.entry}
							onSubmit={this.handleSubmit.bind(this)}
							customers={this.props.customers}
							suppliers={this.props.suppliers}
							ref="form"
						/>
					)}
					{this.state.entry && this.state.entry.purchaseDate && (
						<AssetForm
							accounts={this.props.accounts}
							isNew={this.state.adding}
							vatReg={this.props.vatReg}
							initialValues={this.state.entry}
							onSubmit={this.handleSubmit.bind(this)}
							ref="form"
							assetCategories={this.props.assetCategories}
						/>
					)}
				</Container>
			);
		}
	}
}

const selector = formValueSelector('DEform');

function bindAction(dispatch) {
	return {
		//updateDayTotals: da => dispatch(updateDayTotals(da)),
		//updateCustomerDebt: c=>dispatch(updateCustomerDebt(c)),
		dispatch
	};
}

const mapStateToProps = state => ({
	customers: state.globalReducer.customers,
	suppliers: state.globalReducer.suppliers,
	accounts: state.globalReducer.accounts,
	vatReg: state.globalReducer.busDetails.vatRegistered == 1,
	vatRate: state.globalReducer.busDetails.vatRate,
	jwt: state.loginReducer.jwt && state.loginReducer.jwt.token,
	takingCategories: state.globalReducer.takingCategories,
	expenseCategories: state.globalReducer.expenseCategories,
	assetCategories: state.globalReducer.assetCategories,
	formVals: selector(state, 'paid', 'payable', 'supplier_id', 'expenseCategory_id'),
	entry: state.dailyEntriesReducer.entry
});

export default connect(mapStateToProps, bindAction)(DEformContainer);
